import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { AppShell } from '../components/layout/AppShell';
import { useAuth } from '../lib/auth/store';

export const Route = createFileRoute('/_app')({
  component: AppLayout,
  beforeLoad: () => {
    const state = useAuth.getState();
    if (!state.initialized) return;
    if (!state.user) {
      throw redirect({ to: '/login' });
    }
  },
});

function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
